import { SERVER_API } from 'SharedDir/constants/app/endpoints';

export const measureUrl = `${SERVER_API}/measure-units`;
